export default __webpack_public_path__ + "static/media/mais-vida.34874aa9.svg";